var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'f-message-counter': true,
    'f-message-counter-unread': !_vm.item.read,
    'f-message-counter-big': _vm.big,
    'f-message-counter-disabled': _vm.item.disabled
  },attrs:{"title":_vm.big ? '' : _vm.titleText}},[_c('f-icon',{attrs:{"name":_vm.item.type}}),_c('span',{staticClass:"f-message-counter-value counter"},[_vm._v(_vm._s(_vm.item.counter))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }